import { Grid, Paper } from '@mui/material';
import { parseISO } from 'date-fns';
import { formatDate } from '../../../../utils/dateHelpers';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../reducers';

const SchedulingEngagementDisplay = () => {
    const { memberDocs } = useSelector((state: RootState) => state.officeSchedulerSlice);
    return (
        <Grid size={{ lg: 12 }} sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <Paper
                elevation={2}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '1em',
                    flex: 1,
                    minHeight: 0,
                    maxHeight: '50vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    wordBreak: 'break-word',
                }}
                id="docsEl"
            >
                <p style={{ textAlign: 'center', margin: '0 0 1em 0' }}>Engagement Notes </p>
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    {memberDocs?.length > 0 &&
                        memberDocs.map((doc, i) => (
                            <div key={`${doc.Id}${i}`} style={{ marginBottom: '1em' }}>
                                <Grid container justifyContent="space-between">
                                    <Grid size={{ lg: 4 }}>
                                        <span className="documentation-detail">{formatDate(parseISO(doc.VisitedTime), 'MM/dd/yyyy h:mm aa')}</span>
                                    </Grid>
                                    <Grid size={{ lg: 3 }}>
                                        <span className="documentation-detail">{doc.ReasonForVisit?.Name || ''}</span>
                                    </Grid>
                                    <Grid size={{ lg: 3 }}>
                                        <span className="documentation-detail">{doc.EngagedProvider.Name || ''}</span>
                                    </Grid>
                                </Grid>
                                <div dangerouslySetInnerHTML={{ __html: `${doc.Notes || ''}` }} style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}></div>
                                <hr style={{ margin: '0.5em 0' }}></hr>
                            </div>
                        ))}
                </div>
            </Paper>
        </Grid>
    );
};

export default SchedulingEngagementDisplay;
